import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/_services/common.service';
@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

  isShowPrivacy: boolean = false;
  currentLanguage = this.commonService.currentLanguage;
  
  constructor(public commonService: CommonService) { }

  ngOnInit(): void {
  }

  showPrivacy() {
    this.isShowPrivacy = true
  }

}
